import PriceQuoteDetails from './PriceQuoteDetails';

export default PriceQuoteDetails;
